export default "__VITE_ASSET__Do5a1Zu9__"